import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { MenuServices } from '../../../menu/services';
import { ComboCreateDishSelectPage } from '../../combo-create/combo-create-dish-select/combo-create-dish-select';
import { ComboCreatePricePage } from '../../combo-create/combo-create-price/combo-create-price';
import { ComboCreateTitlePage } from '../../combo-create/combo-create-title/combo-create-title';
import { ComboServices } from '../../services';

/**
 * Generated class for the MenuCreateCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-template-conor',
  templateUrl: 'combo-template-conor.html',
})

export class ComboTemplateConorPage {

  logo_url: any;

  constructor(
    public menuServices: MenuServices,
    public globals: Globals,
    public navCtrl: NavController,
    public comboServices: ComboServices) {
      this.logo_url = this.getImageUrl(this.globals.restaurant.logo);
  }

  uploadImage(){
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

  getImageUrl($img_url) {
    if ($img_url != '') {
      $img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + encodeURIComponent($img_url) + '?alt=media';
      return $img_url;
    } else {
      return '';
    }
  }
  
  bgImg(img) {
    let _img = this.getImageUrl(img);
    let styles = {
      'background-image': 'url("' + _img + '")',
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      '-webkit-background-size': 'cover',
      '-moz-background-size': 'cover',
      '-o-background-size': 'cover',
      'background-size': 'cover',
      'height': '105px',
    }
    return styles;
  }

  showDesc(element) {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        if (element.description_es) {
          return true;
        } else {
          return false
        }
      }
      case 'ca': {
        if (element.description_ca) {
          return true;
        } else {
          return false
        }
      }
      case 'en': {
        if (element.description_en) {
          return true;
        } else {
          return false
        }
      }
      case 'de': {
        if (element.description_de) {
          return true;
        } else {
          return false
        }
      }
      case 'fr': {
        if (element.description_fr) {
          return true;
        } else {
          return false
        }
      }
      case 'it': {
        if (element.description_it) {
          return true;
        } else {
          return false
        }
      }
      default: {
        if (element.description_es) {
          return true;
        } else {
          return false
        }
      }
    }
  }

  editHeader(){
    this.navCtrl.push(ComboCreateTitlePage, {
      type: this.menuServices.menu_tmp.style,
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      template_name: this.menuServices.menu_tmp.template_name,
      tags: this.menuServices.menu_tmp.tags,
      title_es: this.menuServices.menu_tmp.title_es,
      title_ca: this.menuServices.menu_tmp.title_ca,
      title_en: this.menuServices.menu_tmp.title_en,
      title_de: this.menuServices.menu_tmp.title_de,
      title_it: this.menuServices.menu_tmp.title_it,
      title_fr: this.menuServices.menu_tmp.title_fr,
      subtitle_es: this.menuServices.menu_tmp.subtitle_es,
      subtitle_ca: this.menuServices.menu_tmp.subtitle_ca,
      subtitle_en: this.menuServices.menu_tmp.subtitle_en,
      subtitle_de: this.menuServices.menu_tmp.subtitle_de,
      subtitle_it: this.menuServices.menu_tmp.subtitle_it,
      subtitle_fr: this.menuServices.menu_tmp.subtitle_fr,
      reference: this.menuServices.menu_tmp.reference,
      combo_name: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp),
    });
  }

  editElements(section_index){
    this.menuServices.edit = true;
    this.navCtrl.push(ComboCreateDishSelectPage, {
      type: this.menuServices.menu_tmp.style,
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      section: section_index,
      section_complete: this.menuServices.menu_tmp.sections,
      new: false,
    });
  }

  edit(section, index) {
    this.menuServices.edit = true;
    this.menuServices.edit_section = section;
    this.menuServices.edit_index = index;
    this.menuServices.edit_dish_array = this.globals.objectToArray(this.menuServices.edit_section.dish);
    this.menuServices.edit_type = 'dish';
  }

  editFooter() {
    //
    this.menuServices.edit = true;
    this.menuServices.edit_type = 'footer';
    //
    this.navCtrl.push(ComboCreatePricePage, {
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      price: this.menuServices.menu_tmp.price,
      price_takeaway: this.menuServices.menu_tmp.price_takeaway,
      extra_price: this.menuServices.menu_tmp.extra,
      footer: this.menuServices.menu_tmp.footer,
      type: this.menuServices.menu_tmp.style,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-templates/combo-template-conor/combo-template-conor.ts